import React from 'react';
import { useTheme } from 'styled-components';
import { ColumnChart } from '../../../../CommonComponents/OPL/charts/ColumnChart/ColumnChart';
import { formatCurrency } from '../../../../CommonUtils/formatNumber';
import { CHART_HEIGHT } from '../ProjectedIncomeChart.meta';
import { ProjectedIncomeDTO } from '../../../api/useProjectedIncomeQuery';

interface Props {
  data: ProjectedIncomeDTO;
}

export const ProjectedIncomeChartContent = ({ data }: Props) => {
  const theme = useTheme();

  const series = [
    {
      name: 'Projected Income',
      data: data.chartData.map(({ value }) => value),
    },
  ];

  const categories = data.chartData.map(({ label }) => label);

  return (
    <ColumnChart
      series={series}
      categories={categories}
      yAxisType="currency"
      customSettings={{
        series: [
          {
            color: theme.colors.primary['500'],
          },
        ],
        chart: {
          height: CHART_HEIGHT,
        },
        legend: {
          enabled: false,
        },
        tooltip: {
          shared: true,

          formatter() {
            let tooltip = `
                      <span style="font-size: 10px">
                        ${(this as any).x}
                      </span><table>
                    `;

            if ((this as any).points) {
              (this as any).points.forEach(({ y, color, series: { name } }) => {
                tooltip += `
                          <tr>
                            <td>
                              <span style="color:${color}">\u25CF</span> ${name}:
                            </td> 
                            <td>
                              <span style="font-weight: 600">
                                ${formatCurrency(Number(y), { mantissa: 2 })}
                              </span>
                            </td>
                          </tr>
                        `;
              });
            }

            return `${tooltip}</table>`;
          },
        },
      }}
    />
  );
};
